import { IMask } from "react-imask";
import { AT_SYMBOL, CIRCLE_UNICODE } from "../../Constants/CommonConstants";

export const emailMasker = (email) => {
  if (!email) {
    return "";
  }
  const parts = email.split(AT_SYMBOL);
  const username = parts[0];
  const domain = parts[1];

  const usernameLength = username.length;
  const maskedLength = usernameLength;

  const usernameMasker = IMask.createMask({
    mask: `*${"S".repeat(maskedLength - 1)}`,
    blocks: {
      S: {
        mask: CIRCLE_UNICODE,
      },
    },
  });

  usernameMasker.resolve(username);
  const maskedUsername = usernameMasker.displayValue;
  const maskedEmail = `${maskedUsername}@${domain}`;
  return maskedEmail || "";
};
